export default __webpack_public_path__ + "img/dark.d35b89bf.svg";